var map = {
	"./aquaculture.svg": 7464,
	"./arrow-right.svg": 2748,
	"./close.svg": 7066,
	"./language.svg": 368,
	"./menu.svg": 5775,
	"./pause-squared.svg": 7987,
	"./play-squared.svg": 376,
	"./print.svg": 8527,
	"./search.svg": 7286,
	"./toggle.svg": 2374,
	"./wildfish.svg": 8860
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9477;